import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { Account } from '../data/account';
import { Deal } from '../data/deal';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-create-customer-account',
  templateUrl: './create-customer-account.component.html',
  styleUrls: ['./create-customer-account.component.scss']
})
export class CreateCustomerAccountComponent extends BaseComponent implements OnInit {

  loading: boolean = true;
  deal: Deal;
  newAccount: Account = new Account();
  confirmPassword: string;
  
  passwordErrors: { length, upper, lower, other } = { length: false, upper: false, lower: false, other: false };
  confirmPasswordMismatch: boolean = false;

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.dataService.getWonDeal(params.dealId).subscribe(
      success => {
        this.deal = success;
        this.newAccount = new Account();
        this.newAccount.RoleCode = "Admin";
        this.newAccount.IsEnabled = true;
        this.loading = false;
      },
      fail => {
        this.redirectService.redirect();
      });
    });
  }

  validatePassword() {
    if (!this.newAccount) return;
    if (!this.newAccount.Password) this.passwordErrors = { length: false, upper: false, lower: false, other: false };
    else this.passwordErrors = { 
      length: this.newAccount.Password.length < 8,
      upper: !this.newAccount.Password.match(/[A-Z]/),
      lower: !this.newAccount.Password.match(/[a-z]/),
      other: !this.newAccount.Password.match(/[^a-zA-Z]/)
    };

    this.confirmPasswordMismatch = this.newAccount.Password && this.confirmPassword && this.newAccount.Password !== this.confirmPassword;
  }

  createAccount() {
    this.dataService.createAccountFromDeal(this.deal.ID, this.newAccount).subscribe(
      success => {
        if (success){
          this.dataService.createAccountSession(this.newAccount.Email, this.newAccount.Password).subscribe(
          session => {
            if (session != null) {
              this.authService.setSession(session);
              if (session.SessionType === 'Parent') {
                this.redirectService.redirectToParentAccount(session.ID);
              } else {
                this.dataService.getOrganizations()
                  .subscribe(organizations => {
                    this.organizationService.setOrgs(organizations);
                    if (this.authService.isLoggedIn()) {
                      this.router.navigate(['onboard']);
                    }
                  });
              }
            }
          });
        }
      },
      fail => {
        Swal.fire("Something went wrong");
      }
    )
  }

}
